import type { Discipline } from '@obraplan/core/domain/structure/discipline';

/**
 * O resumo do cartão da equipe: as disciplinas que valem hoje e de onde vieram (RN-431).
 */
export function teamDisciplinesSummary(input: {
  readonly disciplines: readonly Discipline[];
  readonly marked: readonly string[];
  readonly majority: readonly string[];
}): { readonly names: readonly string[]; readonly isDefault: boolean } {
  const isDefault = input.marked.length === 0;
  const ids = new Set(isDefault ? input.majority : input.marked);
  const names = input.disciplines
    .filter((discipline) => ids.has(discipline.id) && discipline.isActive)
    .sort((a, b) => a.position - b.position || a.name.localeCompare(b.name))
    .map((discipline) => discipline.name);
  return { names, isDefault };
}
